"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getEndpoint = exports.createUrl = void 0;
const createUrl = (apiPrefix, endpoint, isServer = false, dynamicPathFragments, removeTrailingSlash = true) => {
    const url = `${apiPrefix}${(0, exports.getEndpoint)(endpoint, isServer)}`;
    if (dynamicPathFragments) {
        return Object.keys(dynamicPathFragments).reduce((acc, key) => {
            var _a, _b;
            return acc.replace(`{${key}}`, (_b = (_a = dynamicPathFragments[key]) === null || _a === void 0 ? void 0 : _a.toString()) !== null && _b !== void 0 ? _b : '');
        }, url);
    }
    if (removeTrailingSlash) {
        return url.endsWith('/') ? url.slice(0, -1) : url;
    }
    return url;
};
exports.createUrl = createUrl;
const getEndpoint = (endpoint, isServer = false) => (isServer ? endpoint.server : endpoint.client);
exports.getEndpoint = getEndpoint;
//# sourceMappingURL=createUrl.js.map